import {PaginationState} from "app/shared/pagination/pagination.model";
import {useQuery} from "@tanstack/react-query";
import {fetchNotificationsOverview} from "app/modules/notifications/service/notification.service";

export const fetchNotificationsOverviewQuery = (pagination: PaginationState) => {
  return useQuery({
    queryKey: ['notifications-overview', { ...pagination }],
    queryFn: ({signal}) => fetchNotificationsOverview({signal, pagination}),
  });
};
